// extracted by mini-css-extract-plugin
export default {"dashboard-layout":"dashboard-layout-jfVU2","dashboard-layout--2-cols":"dashboard-layout--2-cols-q2sen"};